/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Box, Stack } from "@mui/material";
import { ReactNode } from "react";
import { alertContentLegalbirdStyle } from "@/src/components/legalbird/AlertLegalbird/alertContentLegalbirdStyle.ts";

export type AlertContentLegalbirdProps = { title?: string; subtitle?: ReactNode; description?: ReactNode; actions?: ReactNode };

export default function AlertContentLegalbird({ title, subtitle, description, actions }: AlertContentLegalbirdProps) {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: !actions ? 12 : 8 }} sx={{ textAlign: "left" }}>
        {!!title && (
          <Typography variant={"body2"} component={"div"}>
            <strong>{title}</strong>
          </Typography>
        )}
        {!!subtitle && (
          <Typography variant={"body3"} component={"div"}>
            {subtitle}
          </Typography>
        )}
        {!!description && (
          <Typography variant={"body3"} sx={(theme) => ({ paddingTop: "1rem", color: theme.palette.text.primary })} component={"div"}>
            {description}
          </Typography>
        )}
      </Grid>
      {!!actions && (
        <Grid size={{ xs: 12, lg: 4 }}>
          <Stack direction={"row"} sx={alertContentLegalbirdStyle.actions}>
            <Box sx={{ width: "fit-content" }}>{actions}</Box>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
}
